import loadable from 'utils/loadable';

export const MyInfo = loadable(
  () => import('./'),
  module => module.MyInfo,
);
